import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormError from "./FormError";
import api from "../api";

export default function PaymentMethodSelector({
  open,
  onClose,
  onSave,
  statementId,
  initialPaymentMethodId = null,
  initialPaymentMethodType = null
}) {
  const [loading, setLoading] = useState(true);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [cards, setCards] = useState([]);
  const [selectedType, setSelectedType] = useState(
    initialPaymentMethodType || "bank_account"
  );
  const [selectedId, setSelectedId] = useState(initialPaymentMethodId || "");
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) {
      setLoading(true);
      api
        .getStatementAvailablePaymentMethods({ id: statementId })
        .then(api.pickData)
        .then((data) => {
          setBankAccounts(data.bankAccounts || []);
          setCards(data.cards || []);
          setLoading(false);
        })
        .catch((err) => {
          setError(err.message || "Failed to load payment methods");
          setLoading(false);
        });
    }
  }, [open, statementId]);

  const handleSave = () => {
    if (!selectedId) {
      setError("Please select a payment method");
      return;
    }

    setLoading(true);
    api
      .updateStatementPaymentMethod({
        id: statementId,
        payment_method_id: selectedId,
        payment_method_type: selectedType
      })
      .then(api.pickData)
      .then((data) => {
        setLoading(false);
        onSave(data);
      })
      .catch((err) => {
        setError(err.message || "Failed to update payment method");
        setLoading(false);
      });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Select Payment Method</DialogTitle>
      <DialogContent>
        {loading ? (
          <div
            style={{ display: "flex", justifyContent: "center", padding: 20 }}
          >
            <CircularProgress />
          </div>
        ) : (
          <FormControl component="fieldset" fullWidth>
            <RadioGroup
              value={`${selectedType}-${selectedId}`}
              onChange={(e) => {
                const [type, id] = e.target.value.split("-");
                setSelectedType(type);
                setSelectedId(id);
              }}
            >
              {bankAccounts.length > 0 && (
                <>
                  <h3>Bank Accounts</h3>
                  {bankAccounts.map((account) => (
                    <FormControlLabel
                      key={`bank_account-${account.id}`}
                      value={`bank_account-${account.id}`}
                      control={<Radio />}
                      label={`${account.name || ""} ${
                        account.last4 ? `**** ${account.last4}` : ""
                      }`}
                    />
                  ))}
                </>
              )}

              {cards.length > 0 && (
                <>
                  <h3>Cards</h3>
                  {cards.map((card) => (
                    <FormControlLabel
                      key={`card-${card.id}`}
                      value={`card-${card.id}`}
                      control={<Radio />}
                      label={`${card.brand || ""} ${
                        card.last4 ? `**** ${card.last4}` : ""
                      }`}
                    />
                  ))}
                </>
              )}
            </RadioGroup>
          </FormControl>
        )}

        {error && <FormError error={error} resetError={() => setError(null)} />}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSave}
          color="primary"
          variant="contained"
          disabled={loading || !selectedId}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
